export class GasNow {
  constructor() {
    this._gasPrice = null
    this._ws = null
  }

  /**
   * 获取GasPrice
   * @return {Promise<Number>}
   */
  async getGasPrice() {
    if (!window.WebSocket) {
      throw 'not support WebSocket'
    }
    if (this._ws === null || this._ws.readyState !== 1) {
      return await this._setWs()
    }
    return this._gasPrice
  }

  /**
   * 设置webSocket
   * @return {Promise<Number>}
   * @private
   */
  _setWs() {
    this._ws = new window.WebSocket('wss://www.gasnow.org/ws/gasprice')
    return new Promise((resolve, reject) => {
      this._ws.addEventListener('message', res => {
        const val = this._parseMessage(res)
        if (val !== null) {
          this._gasPrice = val
          resolve(val)
        }
      })
      this._ws.addEventListener('close', () => {
        reject('Connection is close')
      })
      // 设置超时
      setTimeout(() => {
        reject('timeout')
      }, 15000)
    })
  }

  /**
   * 解析 message 数据
   * @param {{}} message - gasnow返回数据
   * @return {null|Number}
   * @private
   */
  _parseMessage(message) {
    const val = JSON.parse(message.data)
    if (val.type && val.data && val.data.rapid) {
      return val.data.rapid
    } else {
      return null
    }
  }
}
